import React, { useEffect, useState } from "react";
import { getPolistarNewsesAPI } from "../../apis/news_service";
import thumbnail from "../../assets/images/thumbnail_default.jpg";
import thumbnail2 from "../../assets/images/thumbnail_default2.png";
import thumbnail3 from "../../assets/images/thumbnail_default3.png";
import thumbnail4 from "../../assets/images/thumbnail_default4.png";
import thumbnail5 from "../../assets/images/thumbnail_default5.png";
import styles from "../../assets/styles/modules/Newsinfo.module.css";
import { Button, Checkbox, Fade, Paper, Popper } from "@mui/material";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import toast, { Toaster } from "react-hot-toast";
import IosShareIcon from "@mui/icons-material/IosShare";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import mail from "../../assets/images/ico_mail_color.png";
import kakao from "../../assets/images/ico_kakao_color.png";
import { pasteURL } from "../../apis/toast_message";
import {
  addMycorpAPI,
  addScrapAPI,
  checkMycorpAPI,
  checkScrapAPI,
  deleteScrapNewsAPI,
  delMycorpAPI,
} from "../../apis/my_service";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Obscure } from "../../components/common/\bobscuredImage";

const PolistarSingleNews = () => {
  const pathname = window.location.pathname.split("/");
  const [newsId, setNewsId] = useState(pathname[pathname.length - 1]);
  const [news, setNews] = useState(null); // 폴리스타 뉴스 데이터
  // const [scrap, setScrap] = useState(null); // 북마크 여부
  // const [scrapIdx, setScrapIdx] = useState(null)
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [open, setOpen] = useState(false)// 공유 모달창 오픈;
  // const [subject, setSubject] = useState('') // 이메일 제목
  // const [mailBody, setMailBody] = useState('') // 이메일 내용
  // const [isSubscribe, setIsSubscribe] = useState(null)

  const getNewsData = () => {
    getPolistarNewsesAPI(newsId).then((res) => {
      setNews(res);
    });
  };

  useEffect(getNewsData, [newsId]);

  const contentsParse = (content) => {
    const sentence = content.split("\n\n");
    return (
      <p className="content" style={{ marginBottom: "32px" }}>
        {sentence.map((text) => (
          <span>
            {text}
            <br />
            <br />
          </span>
        ))}
      </p>
    );
  };

  // const getRandomThumbnail = () => {
  //     const thumbnailList = [thumbnail, thumbnail2, thumbnail3, thumbnail4, thumbnail5]
  //     if(newsId){
  //         const idx = Math.floor(Math.random()*4)
  //         return thumbnailList[idx]
  //     }
  //     return thumbnailList[0]
  // }

  // const relatedDartNewsClick = (id) => {window.location.replace(`/dart-news/${id}`)}
  // const moveToStock = () => navigate(`/stock/${news.stockcode}`)

  // const notify = (msg, type) => {
  //     if(type === 'success') return toast.success(msg)
  //     else if (type === 'error') return toast.error(msg)
  //     else return toast(msg)
  // };

  // const bookmarkCheck = () => {
  // checkScrapAPI(newsId).then(res => {
  //     if(res.length>0){
  //         setScrap(true)
  //         setScrapIdx(res[0].scrapeidx)
  //     }else {
  //         setScrap(false)
  //     }
  // })
  // }
  // useEffect(bookmarkCheck, [scrap])

  // const bookmarkClick = () => {
  //     if(scrap === true){
  //         deleteScrapNewsAPI(scrapIdx).then(() => {
  //             setScrap(false)
  //             notify('스크랩 목록에서 삭제했습니다',  'success')
  //         })
  //     } else if(scrap === false){
  //         addScrapAPI(news.newsid, "D").then(() => {
  //             setScrap(true)
  //             notify('스크랩 목록에 저장했습니다', 'success')
  //         })
  //     } else {
  //         notify('로그인이 필요합니다.', 'error')
  //     }
  // }

  // const handleClick = () => (e) => {
  //     setAnchorEl(e.currentTarget);
  //     setOpen((prev) =>  !prev);
  // };
  //
  // const handleClose = () => setOpen(false);
  //
  // const mailShare = () => {
  //     const body = `
  //     [뉴스썸]에서 공유한 뉴스입니다.%0D%0A
  //     %0D%0A
  //     뉴스 제목 : ${news.subject}%0D%0A
  //     뉴스 링크 : https://dev-www.newssalad.com${window.location.pathname}%0D%0A
  //     원문 링크 : ${news.url}%0D%0A
  //     %0D%0A
  //     `
  //     setSubject('[뉴스썸] ' + news.subject)
  //     setMailBody(body)
  // }

  // const kakaoShare = (news) => {
  //     window.Kakao.Share.sendCustom({
  //         templateId: 92864,
  //         templateArgs: {
  //             img: news.imgsrc,
  //             newsID: news.newsid,
  //             title: news.subject,
  //             description: news.summary,
  //         }
  //     });
  // }

  // const checkSubscribe = () => {
  //     if(!!news){
  //         checkMycorpAPI(news.stockcode).then(res => {
  //             console.log(res, 'chk subscribe')
  //             setIsSubscribe(res)
  //         })
  //     }
  // }

  // useEffect(checkSubscribe, [news])

  // const subscribeBtnClick = (stockcode,stockname) => {
  //     if(isSubscribe === true){
  //         delMycorpAPI(stockcode).then(() => {
  //             notify('마이기업 삭제가\n 완료 되었습니다.','success')
  //             setIsSubscribe(false)
  //         })
  //     }else if(isSubscribe === false) {
  //         addMycorpAPI(stockcode).then((res) => {
  //             if(res){
  //                 setIsSubscribe(true)
  //                 notify(stockname + ' 이/가 마이기업으로\n등록 되었습니다.\nAI 콴의 다양한 뉴스 분석 콘텐츠를\n 확인해보세요!', 'success')
  //             } else {
  //                 notify(stockname + ' 이/가 이미 존재합니다!', 'error')
  //             }
  //         })
  //     } else {
  //         notify('로그인이 필요합니다.', 'error')
  //     }
  // }

  // useEffect(checkSubscribe, [isSubscribe])

  return (
    <div className="singlenews container">
      <div
        className="inner_container"
        style={{
          display: "flex",
          marginTop: "0",
          marginBottom: "0",
          minHeight: "743px",
        }}
      >
        <div className="dart_container" style={{ border: "none" }}>
          {news && (
            <>
              <div>
                <span
                  style={{
                    fontSize: "13px",
                    letterSpacing: "-0.65px",
                    color: "#555",
                  }}
                >
                  {news.press} · {news.registdate}
                </span>
                <h1>{news.title}</h1>
                <Obscure text={news.press}>
                  <img
                    src={!!news.img_url ? news.img_url : thumbnail}
                    alt="thumbnail"
                    style={{ marginBottom: "22px", width: "80%" }}
                  />
                </Obscure>
                {contentsParse(news.content)}
                {/*TODO:북마크, 공유 기능은 사용자 혼란 방지를 위해 주석처리함.*/}
                {/*<div className='btn_container'>*/}
                {/*    <Checkbox{...label}*/}
                {/*             className='bookmark_btn' sx={{ color:'#999999'}} onClick={bookmarkClick} checked={scrap}*/}
                {/*             icon={<BookmarkBorderOutlinedIcon/>} checkedIcon={<BookmarkIcon/>} />*/}
                {/*    <Toaster containerStyle={{top: 140}}/>*/}
                {/*    <Button sx={{border:'1px solid rgba(0, 40, 100, 0.12)', borderRadius:'50%', minWidth:0, width:'44px', color:'#999999', height: '44px', '&:focus':{border:'1px solid rgba(0, 40, 100, 0.12)'}}}*/}
                {/*            className={styles.share_btn} onClick={handleClick('bottom-start')}>*/}
                {/*        <IosShareIcon/>*/}
                {/*    </Button>*/}
                {/*    <Popper open={open} anchorEl={anchorEl} placement='bottom-start' transition>*/}
                {/*        {({TransitionProps}) => (*/}
                {/*            <Fade {...TransitionProps} >*/}
                {/*                <Paper className={styles.modal}>*/}
                {/*                    <ClearRoundedIcon className={styles.close} onClick={handleClose}/>*/}
                {/*                    <ul className={styles.icon_container}>*/}
                {/*                        <li>*/}
                {/*                            <a href={`mailto:?to=&Subject=${subject}&body=${mailBody}`}><img src={mail} alt='kakao' onClick={mailShare}/></a>*/}
                {/*                        </li>*/}
                {/*                        <li className={styles.icon_name}>메일</li>*/}
                {/*                    </ul>*/}
                {/*                    <ul className={styles.icon_container}>*/}
                {/*                        <li><img src={kakao} alt='kakao' onClick={()=>kakaoShare(news)}/></li>*/}
                {/*                        <li  className={styles.icon_name}>카카오</li>*/}
                {/*                    </ul>*/}
                {/*                    <div className={styles.url} >*/}
                {/*                        <input value={news.url}/>*/}
                {/*                        <button onClick={() => {*/}
                {/*                            pasteURL()*/}
                {/*                            navigator.clipboard.writeText(window.location.href)*/}
                {/*                        }}>URL 복사</button>*/}
                {/*                    </div>*/}
                {/*                </Paper>*/}
                {/*            </Fade>*/}
                {/*        )}*/}
                {/*    </Popper>*/}
                {/*</div>*/}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PolistarSingleNews;
